module.exports = "/_next/static/images/mitra-2-e160fd998a7e1d67d11d07c58f75baef.png";